import {useIntl} from 'react-intl';
import {AppButton} from '@components/Core/buttons/AppButton/AppButton';
import './buttons.less';

export default function Buttons({loginForm, isLoginButtonVisible}) {
    const intl = useIntl();
    const isLoginButtonDisabled = !loginForm.email || !loginForm.password;
    const isContinueButtonDisabled = !loginForm.email;

    return (
        <div className="login-buttons">
            {isLoginButtonVisible ? (
                <AppButton
                    type="submit"
                    disabled={isLoginButtonDisabled}
                    size="small"
                    className="login-button"
                    data-wdio="test-login-form-submit-button"
                    fullWidth
                >
                    {intl.formatMessage({id: 'esl.generic.login', defaultMessage: ''})}
                </AppButton>
            ) : (
                <AppButton
                    type="submit"
                    disabled={isContinueButtonDisabled}
                    size="small"
                    className="continue-button"
                    data-wdio="test-login-form-continue-button"
                    fullWidth
                >
                    {intl.formatMessage({id: 'esl.generic.next', defaultMessage: ''})}
                </AppButton>
            )}
        </div>
    );
}
